/**
 * @generated SignedSource<<a1a6bab33a10fe432772f2b1e7502ccd>>
 * @relayHash eccb371c5b8ec1c54373b42ee12e2013
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID af015521dc59e84bc656e096ee47887ac5fb986352f9a3abc0fc8682d11cc09d

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type csmRequestsListQuery$variables = {
  accountId: string;
  cloudId: string;
  count?: number | null | undefined;
  helpCenterId: string;
};
export type csmRequestsListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"requestsTable_csmRequestsList">;
};
export type csmRequestsListQuery = {
  response: csmRequestsListQuery$data;
  variables: csmRequestsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterId"
},
v4 = {
  "kind": "Variable",
  "name": "accountId",
  "variableName": "accountId"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "helpCenterId",
  "variableName": "helpCenterId"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v6/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "csmRequestsListQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "requestsTable_csmRequestsList"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "csmRequestsListQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/)
        ],
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": [
              (v4/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "individualByAccountId",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v8/*: any*/),
                    "concreteType": "CustomerServiceRequestConnection",
                    "kind": "LinkedField",
                    "name": "requests",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CustomerServiceRequestEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "CustomerServiceRequest",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "summary"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "statusKey"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "createdOn"
                              },
                              {
                                "concreteType": "CustomerServiceTemplateForm",
                                "kind": "LinkedField",
                                "name": "templateForm",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "name"
                                  },
                                  (v9/*: any*/)
                                ]
                              },
                              (v9/*: any*/),
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "args": (v8/*: any*/),
                    "filters": [
                      "helpCenterId"
                    ],
                    "handle": "connection",
                    "key": "requestsTable_requests",
                    "kind": "LinkedHandle",
                    "name": "requests"
                  }
                ],
                "type": "CustomerServiceIndividual"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "identifier"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "statusCode"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "errorType"
                      }
                    ]
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "af015521dc59e84bc656e096ee47887ac5fb986352f9a3abc0fc8682d11cc09d",
    "metadata": {},
    "name": "csmRequestsListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d7873447b992f6c855e26ecc4d15d8f7";

export default node;
